import '../../../../Styles/Toyota.scss'

import React from 'react';
import axios from 'axios';


import Image from 'react-bootstrap/Image';
import ResendLink from '../../Shared/ResendLink';
import ToyotaLogo from '../../../../static/images/Toyota-Logo.svg'
import Loader from '../../../../static/images/loading.gif'
import AppVars from '../../../../AppVars.js'
import Logger from '../../../../Logger.js';
import { constants } from '../../../../constants/constants';

import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';

const appVars = AppVars.getInstance();

class EmailVerificationView extends React.Component {

    constructor(props){
        super(props);
        this.state = {
            ...props,
        }
    }

    render() {
        return(
            <div>
                <div role = "banner">
                    <Image className="login-log-resend" alt = "Toyota" src={ToyotaLogo} />
                </div>
                <div role = "main">
                <div className='title__TO' style={{'marginBottom': '28px', 'marginTop': '124px', 'width':'auto'}}>
                    Let's get your account activated.
                </div>
                <div className='_ngcontent-c1'>
                    Just enter your email and we'll send you an activation link.
                </div>
                <div className='error itemlevel'>
                    <p className={`message__TO successMessage ${this.props.activationEmailSent === true ? "block" : "none"}`}>
                        Email has been sent to {this.props.successEmail}.
                    </p>
                    <p className={`errorMessage message__TO  ${this.props.isUserAlreadyActivated === true ? "block" : "none"}`}>
                        {constants.RESEND_ACTIVATED_ERROR}
                    </p>
                    <p className={`message__TO errorMessage ${this.props.userNotFound === true ? "block" : "none"}`}>
                        {constants.RESEND_NOT_FOUND_ERROR}
                    </p>
                    <p className={`message__TO errorMessage ${this.props.emailFail === true ? "block" : "none"}`}>
                        {constants.RESEND_ERROR}
                    </p>
                </div>
                <Form id='activateEmail__TO' noValidate validated = {this.props.isFormValid} onSubmit={this.props.handleFormSubmit}>
                        <Form.Group className = "relative">
                        <Form.Label className = {`${this.props.onFocus === false ? "absolute floating-label" : "absolute inline-label" }
                        ${this.props.onFocus === true ? "label-black__TO" : "" }
                        ${this.props.isFormValid === false ? "label-red__TO" : ""}
                        `}>
                    Email
                    <span id="redStar">*</span></Form.Label>
                            <Form.Control
                                id='email__TO'
                                data-testid='email'
                                aria-label='Email'
                                as='input'
                                type='text'
                                name='email'
                                value = {this.props.email}
                                onChange = {this.props.handleEmailChange}
                                onFocus = {this.props.setFocus}
                                onBlur = {this.props.removeFocus}
                                bsPrefix = {`${this.props.isFormValid === false ? "highlight-error__TO form-control" : ""}`}
                            />
                        </Form.Group>
                        <div
                            id = "emailValidationAlert"
                            data-testid = "emailValidationError"  
                            className = {`logon-item-error__TO ${this.props.isFormValid === false ? "block" : "none"}`}
                            role = "alert" 
                            aria-hidden = {`${this.props.isFormValid === false ? "false" : "true"}`}
                        >
                                Please enter a valid email address
                        </div>
                        <Button style = {{"marginTop" : "30px"}} id='resend-button' data-testid = "activateEmailButton" bsPrefix = "button__TO" type = "submit" >Resend Activation Email</Button>
                </Form>
                </div>
                <div className={`${this.props.loading === true ? "resend-background" : "none" }`}>
                    <div className="spinner">
                    <img className='spinner-img' src={Loader} />
                    </div>
                </div>
            </div>
        )
    }


}

export default EmailVerificationView